export interface PositionedArtifact {
  artifactId: string;
  contentSplitIndex: number;
}

export interface ArtifactSegment<T extends PositionedArtifact> {
  text: string;
  artifact?: T;
}

export const splitAroundArtifacts = <T extends PositionedArtifact>(
  content: string,
  artifacts: readonly T[] | undefined
): ArtifactSegment<T>[] => {
  if (artifacts === undefined || artifacts.length === 0) {
    return [{ text: content }];
  }

  const ordered = [...artifacts].sort(
    (a, b) => a.contentSplitIndex - b.contentSplitIndex
  );

  const segments: ArtifactSegment<T>[] = [];
  let cursor = 0;

  for (const artifact of ordered) {
    const boundary = Math.min(
      Math.max(artifact.contentSplitIndex, cursor),
      content.length
    );
    segments.push({ text: content.slice(cursor, boundary), artifact });
    cursor = boundary;
  }

  segments.push({ text: content.slice(cursor) });

  return segments;
};
